export const navigation = () => {

	toggle()
	accordion()
}

const toggle = () => {
	const els = document.querySelectorAll('.toggle-navigation')

	if (!els.length) return false

	els.forEach(el => {
		el.addEventListener('click', e => {
			if (document.body.getAttribute('data-navigation-status')) {
				document.body.removeAttribute('data-navigation-status')
			} else {
				document.body.setAttribute('data-navigation-status', 'open')
			}
			e.preventDefault()
		})
	})

	document.onkeydown = e => {
		e = e || window.event
		if (e.keyCode == 27) document.body.removeAttribute('data-navigation-status')
	}
}

const accordion = () => {

	let els = document.querySelectorAll('.is-accordion')

	els.forEach(el => {
		let submenu = el.querySelector('.sub-menu')

		if (submenu) {
			const arrow = document.createElement('span')
			arrow.classList.add('accordion-arrow')
			arrow.setAttribute('data-status', 'closed')

			let link = el.querySelector('a')
			link.appendChild(arrow)

			submenu.style.maxHeight = '0'
			submenu.style.overflow = 'hidden'
			submenu.style.transition = 'max-height 0.3s ease'

			arrow.addEventListener('click', function (e) {
				e.stopPropagation()
				e.preventDefault()

				let status = arrow.getAttribute('data-status') === 'open'

				els.forEach(item => {
					let otherArrow = item.querySelector('.accordion-arrow')
					let otherSub = item.querySelector('.sub-menu')
					if (otherArrow && otherArrow !== arrow) {
						otherArrow.setAttribute('data-status', 'closed')
						otherSub.style.maxHeight = '0'
					}
				})

				if (status) {
					submenu.style.maxHeight = '0'
					arrow.setAttribute('data-status', 'closed')
				} else {
					submenu.style.maxHeight = submenu.scrollHeight + 'px'
					arrow.setAttribute('data-status', 'open')
				}
			})
		}
	})
}

export default () => { }